module.exports = __webpack_public_path__ + "img/icon_menu_more.20e21c69.svg";